import { BaseDto } from './base.dto';

export class StockOrderItemDto extends BaseDto {
  stockOrderId: number;
  productStockId: number;
  unitQuantity: number;
  weightQuantity: number;
}
